import { Link } from 'react-router-dom';

const VARIANTS = [
    { id: 'home', label: 'Original', path: '/' },
    { id: 'v2', label: 'v2 — Workspace warm', path: '/home-v2' },
    { id: 'v3', label: 'v3 — Bento', path: '/home-v3' },
    { id: 'v4', label: 'v4 — Bright candy', path: '/home-v4' },
    { id: 'v5', label: 'v5 — Editorial', path: '/home-v5' },
    { id: 'v3.1', label: 'v3.1 — Paper canvas', path: '/home-v3-1' },
    { id: 'v3.2', label: 'v3.2 — Dark hero', path: '/home-v3-2' },
    { id: 'v3.3', label: 'v3.3 — Monument', path: '/home-v3-3' },
    { id: 'v3.4', label: 'v3.4 — Bands', path: '/home-v3-4' },
];

const FALLBACK_LINK_STYLE: React.CSSProperties = {
    padding: '4px 10px',
    borderRadius: 999,
    border: '1px solid rgba(120, 90, 50, 0.1)',
    color: '#3a342f',
    textDecoration: 'none',
    fontWeight: 500,
};

const FALLBACK_ACTIVE_STYLE: React.CSSProperties = {
    background: '#1f1a14',
    color: '#fff',
    borderColor: '#1f1a14',
};

const FALLBACK_NAV_STYLE: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
    fontSize: 11,
    color: '#6f6660',
};

export type VariantId = 'home' | 'v2' | 'v3' | 'v4' | 'v5' | 'v3.1' | 'v3.2' | 'v3.3' | 'v3.4';

export function VariantSwitcher({
    current,
    className,
    activeClass,
}: {
    current: VariantId;
    className?: string;
    activeClass?: string;
}) {
    const useInline = !className;

    return (
        <nav
            className={className}
            style={useInline ? FALLBACK_NAV_STYLE : undefined}
            aria-label="Dashboard design variant"
        >
            <span style={{ fontSize: 11, marginRight: 4 }}>Design:</span>
            {VARIANTS.map((v) => {
                const active = current === v.id;
                return (
                    <Link
                        key={v.id}
                        to={v.path}
                        className={active ? activeClass : undefined}
                        style={
                            useInline
                                ? { ...FALLBACK_LINK_STYLE, ...(active ? FALLBACK_ACTIVE_STYLE : {}) }
                                : undefined
                        }
                    >
                        {v.label}
                    </Link>
                );
            })}
        </nav>
    );
}
